import axios from '../api';
import store from '../store';
import Constants from './../constants';

export default {
  namespaced: true,

  state: {
    listModulesPages: [],

    //saved: false,
    friseDatas: [],
    friseFilter: {},

    infosPass:{
      id_pass: '',
      name: '',
    },

    infosPage: {
      id_page: 1,
      id_module: 1,
      libelle_module: '',
      libelle_page: '',
      goal: 0,
      progress: 0,
      id_template: 0,
      libelle_template: '',
      progress_bar: false,
      isFormChanged: false, //to know if there is change in form. If it's true, a message will appear
    },

    templateContent: [],
    formContent: {},
    baseContent: {},
    listEvaluations: [],

    loading: false,
    messageHeader: '',

    canAutoSave: true,

    errors: null,

    jobs: [],
    job: 0,
    jobForm: { activites: [] },
    jobType: '',
    jobId: 0,

    currentEval: undefined,
  },

  getters: {
    baseContent(state) {
      return state.baseContent;
    },

    templateContent(state) {
      return state.templateContent;
    },

    listModulesPages(state) {
      return state.listModulesPages;
    },

    infosPage(state) {
      return state.infosPage;
    },

    infosPass(state) {
      return state.infosPass;
    },

    formContent(state) {
      return state.formContent;
    },

    friseDatas(state) {
      return state.friseDatas;
    },

    loading(state) {
      return state.loading;
    },

    messageHeader(state) {
      return state.messageHeader;
    },

    listEvaluations(state) {
      return state.listEvaluations;
    },

    friseFilter(state) {
      return state.friseFilter;
    },

    errors(state) {
      return state.errors;
    },

    canAutoSave(state) {
      return state.canAutoSave;
    },

    jobs(state){
      return state.jobs;
    },

    job(state){
      return state.job;
    },

    jobForm(state){
      return state.jobForm;
    },

    jobType(state){
      return state.jobType;
    },

    jobId(state){
      return state.jobId;
    },

    currentEval(state){
      return state.currentEval;
    },
  },

  mutations: {
    SET_BASECONTENT(state, contents){
      state.baseContent = JSON.parse(JSON.stringify(contents));
    },

    SET_TEMPLATECONTENT(state, template) {
      state.templateContent = template;
    },

    SET_LISTMODULESPAGES(state, modules) {
      state.listModulesPages = modules;
    },

    SET_INFOSPASS(state, infos) {
      state.infosPass = infos;
    },

    SET_INFOSPAGE(state, infos) {
      state.infosPage = infos;
    },

    SET_FORMCONTENT(state, contents) {
      state.formContent = contents;
    },

    SET_FRISEDATAS(state, contents) {
      state.friseDatas = contents;
    },

    SET_LOADING(state, loadornot) {
      state.loading = loadornot;
    },
    SET_MESSAGEHEADER(state, progress) {
      state.messageHeader = progress;
    },

    SET_LISTEVALUATIONS(state, list) {
      state.listEvaluations = list;
    },

    SET_FRISEFILTER(state, filter) {
      state.friseFilter = filter;
    },

    SET_ERRORS(state, err) {
      state.errors = err;
    },

    SET_CANAUTOSAVE(state, bool) {
      state.canAutoSave = bool;
    },

    SET_JOBS(state, list){
      state.jobs = list;
    },

    SET_JOB(state, num){
      state.job = num;
    },

    SET_JOBFORM(state, form){
      state.jobForm = form;
    },

    SET_JOBTYPE(state, type){
      state.jobType = type;
    },

    SET_JOBID(state, id){
      state.jobId = id;
    },

    SET_CURRENT_EVAL(state, evaluation) {
      state.currentEval = evaluation;
    },

    //each input modified call this mutation to calculate the percentage progress on page
    calculate_progress(state) {
      let fields = document.querySelectorAll('[necessary=true]'),
        completeFields = 0,
        val = null;

      if (fields.length > 0) {
        setTimeout(() => {
          fields.forEach((element) => {
            val = element._value;
            if (val !== null && val !== undefined && val !== '') {
              completeFields++;
            }
          });

          //update progress for progress bar
          state.infosPage.progress = Math.ceil(
            (completeFields / fields.length) * 100
          );
          //update progress in listModulesPages for menu formulaire
          if (
            state.listModulesPages.filter(
              (m) => m.id === state.infosPage.id_module
            ).length > 0
          ) {
            state.listModulesPages
              .filter(
                (m) => m.id === state.infosPage.id_module
              )[0]
              .pages.filter(
                (p) => p.id == state.infosPage.id_page
              )[0].progress = state.infosPage.progress;
          }
        }, 0);
      }
    },
  },

  actions: {
    async load_infos_pass(context, id) {
      console.log('wait...load_infos_pass');
      await axios
        .get('/api/users/' + id)
        .then((response) => {
          if (response.data == -1) {
            this.$router.push('/not-allowed');
          } else {
            /* Load datas for the form */
            let name =
                            response.data.firstname +
                            ' ' +
                            response.data.lastname.toUpperCase();
            let infos = {
              id_pass: id,
              name: name,
              lastname: response.data.lastname,
              firstname: response.data.firstname,
            };
            context.commit('SET_INFOSPASS', infos);
          }
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async loadModulesPages(context) {
      console.log('wait...loadModulesPages');
      let id_pass = context.getters.infosPass.id_pass;
      await axios
        .get('/api/modules/getModulesPages/neopass/' + id_pass)
        .then((response) => {
          let list = response.data;
          let list_mod = [];
          list.forEach(function (mod, index_mod, list_m) {
            let list_pages = [];
            mod.pages.forEach(function (page, index_page, list_p) {
              if (
                store.getters[
                  'auth/permissionsOnBeneficiariesNeopass'
                ][id_pass].includes(page.name + '_read') ||
                                store.getters[
                                  'auth/permissionsOnBeneficiariesNeopass'
                                ][id_pass].includes(page.name + '_edit')
              ) {
                list_pages.push(page);
              }
            });
            if (list_pages.length > 0) {
              mod.pages = list_pages;
              list_mod.push(mod);
            }
          });
          context.commit('SET_LISTMODULESPAGES', list_mod);
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async update_infos_page(context, url) {
      console.log('wait...update_infos_page');

      //Disable autosave to avoid saving wrong page
      context.commit('SET_CANAUTOSAVE', false);

      let mod = context.getters.listModulesPages.filter(
        (m) => m.name == url[1]
      )[0];
      let page = mod.pages.filter((p) => p.name == url[2])[0];

      let progress_bar = true;

      const disallowedModules = [
        Constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS,
        Constants.MODULE_NEOPASS_FORM_PRECONISATIONS,
      ];

      const disallowedPages = [
        Constants.PAGE_NEOPASS_FORM_DOCUMENTS,
        Constants.PAGE_NEOPASS_FORM_PORTFOLIO,
      ];

      if (disallowedModules.includes(mod.name) || disallowedPages.includes(page.name)) {
        progress_bar = false;
      }

      /*let progress_bar =
                page.name === Constants.PAGE_NEOPASS_FORM_DOCUMENTS &&
                mod.name === Constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS
                  ? false
                  : true;
      progress_bar = !(
        mod.name === Constants.MODULE_NEOPASS_FORM_PRECONISATIONS
      );*/
      let id_template = 0;
      let libelle_template = '';

      if (Constants.LIST_EVALUATION_PAGES.includes(page.name)) {
        await axios
          .get(
            '/api/page_templates/getReferentielTemplate/' +
                            page.id +
                            '/' +
                            url[0]
          )
          .then((response) => {
            if (response.data !== '') {
              progress_bar =
                                response.data.type !== 'clea' &&
                                response.data.type !== 'clea_num' &&
                                response.data.type !== 'ref_clea' &&
                                response.data.type !== 'ref_clea_num';
              id_template = response.data.id;
              libelle_template = response.data.name;
              if (
                response.data.data.length > 0 ||
                                response.data.data != null
              ) {
                context.commit(
                  'SET_TEMPLATECONTENT',
                  response.data.data
                );
              } else {
                context.commit('SET_TEMPLATECONTENT', {});
              }
            }
          })
          .catch((error) => {
            console.log('ERRRR:: ', error);
          });
      }

      let infos = {
        id_module: mod.id,
        id_page: page.id,
        libelle_module: mod.display_name,
        libelle_page: page.display_name,
        name_module: mod.name,
        name_page: page.name,
        goal: page.progress_goal,
        progress: 0,
        id_template: id_template,
        libelle_template: libelle_template,
        progress_bar: progress_bar,
        isFormChanged: false,
      };

      context.commit('SET_INFOSPAGE', infos);
    },

    async load_datas(context) {
      console.log('wait...load_datas');
      let infosPass = context.getters.infosPass;
      let infosPage = context.getters.infosPage;

      await axios
        .get(
          '/api/neopass_datas/' +
                        infosPass.id_pass +
                        '/' +
                        infosPage.id_page
        )
        .then((response) => {
          /* Load datas for the form */
          let datas = response.data.data;

          if (
            datas !== false &&
                        datas !== undefined &&
                        datas !== null
          ) {
            //to verify there are datas
            infosPage.progress = response.data.progress;
            context.commit('SET_INFOSPAGE', infosPage);
            context.commit('SET_FORMCONTENT', datas);
            context.commit('SET_CURRENT_EVAL', response.data);
          } else {
            context.commit('SET_FORMCONTENT', {});
            context.commit('SET_CURRENT_EVAL', undefined);
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            context.commit('SET_FORMCONTENT', {});
            context.commit('SET_CURRENT_EVAL', undefined);
          }
          console.log('ERRRR:: ', error);
        });
    },

    async loadFriseDatas(context) {
      console.log('wait...loadFriseDatas');

      let infosPass = context.getters.infosPass;

      context.commit('SET_FRISEDATAS', {});

      await axios
        .get('/api/datafrise/' + infosPass.id_pass)
        .then((response) => {
          let datas = response.data;
          context.commit('SET_FRISEDATAS', datas);

          //init filter
          let filter = {};

          context.getters.friseDatas
            .filter((d) => d.type != 'empty')
            .forEach((data) => {
              if (data.type == 'multi') {
                data.event.forEach((e) => {
                  filter[e.event.type] = true;
                });
              } else {
                filter[data.event.type] = true;
              }
            });
          context.commit('SET_FRISEFILTER', filter);
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async load_evaluations(context) {
      console.log('wait...load_evaluations');

      let infosPass = context.getters.infosPass;
      let infosPage = context.getters.infosPage;

      await axios
        .get('/api/neopass/evaluations/' + infosPass.id_pass)
        .then((response) => {
          /* Load evaluation */
          let datas = response.data.filter(
            (e) =>
              e.template &&
                            e.template.page_id == infosPage.id_page
          );

          if (datas.length > 0) {
            context.commit('SET_LISTEVALUATIONS', datas);
          } else {
            context.commit('SET_LISTEVALUATIONS', []);
          }
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    async save_silent(context, datas) {
      console.log('silent save...');
      const [infosPage, infosPass] = [
        context.getters.infosPage,
        context.getters.infosPass,
      ];

      await axios
        .put(`/api/neopass_datas/${infosPass.id_pass}`, {
          page: infosPage,
          data: datas,
        })
        .then((response) => {
          if (response.data === 0 || response.status === 204) {
            return;
          }
          context.commit('SET_CURRENT_EVAL', response.data);
          context.commit('SET_ERRORS', null);
          store.dispatch('cartographiesIndividuelles/load_evaluations');
          context.getters.infosPage.isFormChanged = false;
        }).catch(() => {
          //
        });
    },

    async save_datas(context, datas) {
      console.log('saving...');
      let infosPage = context.getters.infosPage;
      let infosPass = context.getters.infosPass;

      await axios.put('/api/neopass_datas/'+infosPass.id_pass, {page: infosPage, data: datas}).then((r) => {
        if(r.data == 0)
        {
          context.commit('SET_MESSAGEHEADER', 'noContent');
          setTimeout(() => {context.commit('SET_MESSAGEHEADER', '');}, 3000);
          return;
        }
        context.commit('SET_CURRENT_EVAL', r.data);
        context.commit('SET_MESSAGEHEADER', 'saveIsSuccess');
        context.commit('SET_ERRORS', null);
        store.dispatch('cartographiesIndividuelles/load_infos_pass', infosPass.id_pass).then(_ => store.dispatch('cartographiesIndividuelles/load_evaluations'));
        context.getters.infosPage.isFormChanged = false;
        setTimeout(() => {context.commit('SET_MESSAGEHEADER', '');}, 3000);

      }).catch(error => {
        if(error.response.data == -1) //if edit this page is not allowed
        {
          context.commit('SET_MESSAGEHEADER', 'saveNotAllowed');
          setTimeout(() => {context.commit('SET_MESSAGEHEADER', '');}, 3000);
        }

        context.commit('SET_ERRORS', error.response.data.errors);
        context.commit('SET_MESSAGEHEADER', 'error');
        setTimeout(() => {context.commit('SET_MESSAGEHEADER', '');}, 3000);
        console.log('ERRRR:: ',error);
      });
    },

    async close_evaluation(context, datas) {
      let infosPage = context.getters.infosPage;
      let infosPass = context.getters.infosPass;

      await axios
        .put('/api/neopass/closeEvaluation/' + infosPass.id_pass, {
          page: infosPage,
          data: datas,
        })
        .then((r) => {
          if (r.data == -1) {
            //if edit this page is not allowed
            context.commit('SET_MESSAGEHEADER', 'saveNotAllowed');
            setTimeout(() => {
              context.commit('SET_MESSAGEHEADER', '');
            }, 3000);
          } else {
            context.getters.infosPage.isFormChanged = false; //to permit the page change without saving (close eval already save datas)
          }
        })
        .catch((error) => {
          context.commit('SET_MESSAGEHEADER', 'error');
          setTimeout(() => {
            context.commit('SET_MESSAGEHEADER', '');
          }, 3000);
          console.log('ERRRR:: ', error);
        });

      await context.dispatch('load_evaluations');
    },

    checkContent(context, url) {
      if (!context.getters.infosPage.isFormChanged) {
        return true; //go to next page
      } else {
        context.commit('SET_MESSAGEHEADER', {
          type: 'INPUT',
          msg: 'Vous avez des modifications non sauvegardées',
          url: url,
        });
        return false;
      }
    },

    async remove_poste(context, numero) {
      let userId = context.getters.infosPass.id_pass;

      return await axios
        .delete('/api/work_station/' + userId + '/' + numero)
        .then((response) => {
          return response.status;
        })
        .catch((error) => {
          throw error.response.status;
        });
    },

    getJob(context) {
      context.commit('SET_JOBFORM', { activities: [] });
      context.commit('SET_JOBTYPE', '');
      context.commit('SET_JOB', parseInt(context.getters.infosPage.name_page.slice(1)));
    },

    async loadJobs(context) { // anciennement getJobs()
      await axios
        .get('/api/work_station/' + context.getters.infosPass.id_pass)
        .then((response) => {
          let workStations = response.data;
          let jobs = [];
          for (let i = 1; i <= 5; i++) {
            jobs.push(
              workStations.filter((station) => station.number == i)[0] || {}
            );
          }
          context.commit('SET_JOBS', jobs);

          // case no job in current page
          if (
            context.getters.jobs[context.getters.job - 1].number === undefined &&
              store.getters.role !== Constants.ROLE_BENEFICIAIRE
          ) {
            store.commit('jobs/SET_USER_JOBS', context.getters.jobs);
            return;
          }

          store.commit('jobs/SET_USER_JOBS', context.getters.jobs);
          context.dispatch('load_infos_job', context.getters.jobs[context.getters.job - 1].sheet_id);
        })
        .catch((error) => {
          console.log('ERRRR::', error);
        });
    },

    async load_infos_job(context, id) {
      store.commit('app/SET_LOADING', true);
      console.log('wait...load_infos_job');
      if (isNaN(id)) {
        context.commit('SET_JOBID', id);
      } else {
        await axios
          .get('/api/sheets/' + id)
          .then((response) => {
            /* Load datas for the form */
            if (response.data.deleted_at !== null) {
              context.commit('SET_JOBFORM', response.data);
              return;
            }

            context.commit('SET_JOBFORM', response.data.data);
            context.commit('SET_JOBID', id);
            context.commit('SET_JOBTYPE', response.data.type);
          })
          .catch((error) => {
            console.log('ERRRR:: ', error);
          });
      }
      store.commit('app/SET_LOADING', false);
    },

    async first_load_page(context, url) {
      await context.dispatch('load_infos_pass', url[0]);
      await context.dispatch('loadModulesPages');
    },

    async change_page(context, url) {
      await context.dispatch('update_infos_page', url);
      await context.dispatch('load_datas');
      await context.dispatch('load_evaluations');
    },
  },
};
